import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {PRIMARY_RED} from '../../../const/colors';
import {desktop, mobile} from '../../../const/sizes';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formGroup: {
            marginTop: desktop.contentSmallerSpacing,
        },
        passwordLabelContainer: {
            width: '100%',
        },
        passwordStrengthBarContainer: {
            flex: 1,
            marginLeft: 10,
            marginBottom: 10,
        },
        formSubsection: {
            marginTop: mobile.contentLargerSpacing,
        },
        submitContainer: {
            width: '100%',
            marginTop: mobile.contentLargerSpacing,
        },
        submitButton: {
            width: '100%',
        },
        termsAndConditionLink: {
            color: PRIMARY_RED,
        },
        houseNumber: {},
        [theme.breakpoints.up('sm')]: {
            submitButton: {
                width: 300,
            },
        },
    }),
);

export default useStyles;
